import { useQuery } from '@tanstack/vue-query'
import { offeringPropertyQueryKeys } from '../offeringPropertyQueryKeys'
import { getOfferingStatusCounts } from '../offeringPropertyEndpoints'
import type { OfferingStatusCountsDto } from '../offeringContracts'

export type OfferingStatusCounts = OfferingStatusCountsDto

// Sidebar work-queue badge counts for the Offerings menu. Shares the
// offeringPropertyQueryKeys.all tree, so every offering mutation that
// invalidates `.all` (approve / reject / submit / send-to-vasp / sync /
// bypass) refreshes these badges without an extra fetch.
export function useOfferingStatusCountsQuery() {
  return useQuery({
    queryKey: offeringPropertyQueryKeys.statusCounts(),
    queryFn: () => getOfferingStatusCounts(),
    staleTime: 60_000,
  })
}
